<template>
  <project-manager-layout :spinning="isLoading">
    <leader-project-layout :model="model">
      <template #underInfo>
        <div class="leader-project__common-progress" v-if="model.id">
          <progress-bar-generated
            :show-label="true"
            :completed="model.completedCount"
            :completed-overdue="model.completedOverdueCount"
            :incomplete-overdue="model.incompleteOverdueCount"
            :incomplete="model.incompleteCount"
          />
        </div>
      </template>
      <a-row class="project-management__team">
        <team-member-add
          v-if="!showExecutorProfile"
          @update="onExecutorsUpdate"
        />
        <template v-if="!showExecutorProfile">
          <team-member-card
            v-for="executor in team"
            :key="executor.id"
            :executor="executor"
            :is-my-project="model.isMyProject"
            @click="handleShowExecutorProfile(executor)"
            @update="onExecutorsUpdate"
          />
        </template>
      </a-row>
      <team-member-profile
        v-if="showExecutorProfile"
        :executor="currentExecutor"
        :disabled="true"
        :is-project-external="model.isExternal"
        @close="handleHideExecutorProfile"
      />
    </leader-project-layout>
  </project-manager-layout>
</template>

<script setup>
  import { onMounted, reactive, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import ProjectManagerLayout from '@/layouts/ProjectManagerLayout.vue';
  import LeaderProjectLayout from '@/views/leader/projects/components/LeaderProjectLayout.vue';
  import TeamMemberCard from '@/components/projects/team/TeamMember/TeamMemberCard.vue';
  import TeamMemberProfile from '@/components/projects/team/TeamMember/TeamMemberProfile.vue';
  import TeamMemberAdd from '@/components/projects/team/TeamMember/TeamMemberAdd.vue';
  import ProgressBarGenerated from '@/components/projects/portfolio/components/ProgressBarGenerated.vue';

  const api = useApi();
  const route = useRoute();
  const model = reactive({
    id: null,
    number: '',
    name: '',
    description: '',
    projectType: '',
    requestId: null,
    status: null,
    isExternal: false,
    isMyProject: false,
    projectStatusId: null,
    completedCount: 0,
    completedOverdueCount: 0,
    incompleteOverdueCount: 0,
    incompleteCount: 0,
  });
  const showExecutorProfile = ref(false);
  const currentExecutor = ref(null);
  const team = ref([]);
  const isLoading = ref(true);

  onMounted(async () => {
    await getModel();
    await getTeam();
    isLoading.value = false;
  });

  const getModel = async () => {
    try {
      const response = await api.leaderPage.view(route.params.id);
      model.name = response.project.name;
      model.number = response.project.id;
      model.id = response.project.id;
      model.type = response.project.type;
      model.requestId = response.project.requestId;
      model.status = response.project.status;
      model.isExternal = response.project.isExternal;
      model.isMyProject = response.project.isMyProject;
      model.projectStatusId = response.project.projectStatusId;
      model.completedCount = response.project.completedCount;
      model.completedOverdueCount = response.project.completedOverdueCount;
      model.incompleteOverdueCount = response.project.incompleteOverdueCount;
      model.incompleteCount = response.project.incompleteCount;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getTeam = async () => {
    try {
      const response = await api.projectExecutor.stats(
        new URLSearchParams({
          projectId: route.params.id,
          sort: '-isLeader,lastName,firstName,middleName',
        })
      );
      team.value = response.executors.items;
    } catch (error) {
      console.error('error', error);
    }
  };

  const handleShowExecutorProfile = (executor) => {
    currentExecutor.value = executor;
    showExecutorProfile.value = true;
  };

  const handleHideExecutorProfile = () => {
    currentExecutor.value = null;
    showExecutorProfile.value = false;
  };

  const onExecutorsUpdate = async () => {
    await getTeam();
  };
</script>

<style lang="scss" scoped>
  .leader-project__common-progress {
    margin-top: 42px;
  }

  .project-management__team {
    column-gap: 20px;
    row-gap: 20px;
  }
</style>
